import React from 'react'
import styled from 'styled-components'
import Filler from './Filler'
import { innerBoxShadow } from './progressHelpers.js'

const StyledProgressBar = styled.div`
	width: 100%;
	height: 16px;
	background-color: ${({ backgroundColor = 'white' }) => backgroundColor};
	border-radius: 50px;
	${({ theme, borderColor = theme.main }) => innerBoxShadow(borderColor)}
	margin: 0.5em auto;
	position: relative;
`

const ProgressBar = ({ fillers = [], time = 1.2, ...props }) => (
	<StyledProgressBar {...props}>
		{fillers
			.sort((a, b) => b - a)
			.map((filler, index) => (
				<Filler
					key={index}
					rank={index}
					progress={filler}
					time={time}
					{...props}
				/>
			))}
	</StyledProgressBar>
)

export default ProgressBar



// WEBPACK FOOTER //
// ./src/artzu-ui/src/ProgressBar/index.js